/**
 * LSP-17773: free-mail providers where a shared email domain proves NOTHING about two people
 * being the same company. Module-level (review: was rebuilt per ShareInviteField instance) and
 * shared so every invite/validation surface that reasons about "same company" uses one list.
 *
 * Consumers must apply this ONLY to same-company INFERENCE (e.g. the share dialog's
 * "Same company — but not on your team yet" card), never to exact-identity checks — a real
 * teammate whose org signed up on gmail.com still matches the team roster by exact email.
 */
export const PUBLIC_EMAIL_DOMAINS: ReadonlySet<string> = new Set([
	"gmail.com",
	"googlemail.com",
	"yahoo.com",
	"yahoo.co.uk",
	"yahoo.co.in",
	"yahoo.ca",
	"yahoo.co.jp",
	"yahoo.fr",
	"yahoo.de",
	"yahoo.com.br",
	"yahoo.com.au",
	"ymail.com",
	"outlook.com",
	"outlook.fr",
	"outlook.de",
	"outlook.es",
	"outlook.co.uk",
	"hotmail.com",
	"hotmail.co.uk",
	"hotmail.fr",
	"hotmail.de",
	"hotmail.it",
	"hotmail.es",
	"live.com",
	"live.co.uk",
	"live.fr",
	"live.nl",
	"live.ca",
	"msn.com",
	"icloud.com",
	"me.com",
	"mac.com",
	"aol.com",
	"proton.me",
	"protonmail.com",
	"pm.me",
	"mail.com",
	"gmx.com",
	"gmx.net",
	"zoho.com",
	"yandex.com",
	"rediffmail.com",
	// Review medium #4: the list was US/EN-centric — the same-company false positive this
	// helper exists to prevent reproduced verbatim for any large non-US provider. Regional
	// majors and the missing yahoo/hotmail/live ccTLD variants:
	"yahoo.es",
	"yahoo.it",
	"yahoo.com.mx",
	"yahoo.com.ar",
	"yahoo.gr",
	"hotmail.ca",
	"hotmail.com.br",
	"hotmail.com.ar",
	"hotmail.com.mx",
	"hotmail.nl",
	"live.de",
	"live.it",
	"live.com.mx",
	"live.com.au",
	"outlook.it",
	"outlook.com.br",
	"mail.ru",
	"bk.ru",
	"inbox.ru",
	"list.ru",
	"yandex.ru",
	"qq.com",
	"163.com",
	"126.com",
	"sina.com",
	"sohu.com",
	"naver.com",
	"daum.net",
	"hanmail.net",
	"web.de",
	"gmx.de",
	"gmx.at",
	"gmx.ch",
	"t-online.de",
	"freenet.de",
	"orange.fr",
	"wanadoo.fr",
	"free.fr",
	"sfr.fr",
	"laposte.net",
	"libero.it",
	"virgilio.it",
	"tiscali.it",
	"terra.com.br",
	"uol.com.br",
	"bol.com.br",
	"comcast.net",
	"verizon.net",
	"att.net",
	"sbcglobal.net",
	"cox.net",
	"charter.net",
	"btinternet.com",
	"sky.com",
	"talktalk.net",
	"virginmedia.com",
	"shaw.ca",
	"rogers.com",
	"sympatico.ca",
	"telus.net",
	"bigpond.com",
	"optusnet.com.au",
	"xtra.co.nz",
	"seznam.cz",
	"wp.pl",
	"onet.pl",
	"interia.pl",
	"o2.pl",
	"abv.bg",
	"ukr.net",
	"rambler.ru",
	"zohomail.com",
	"fastmail.com",
	"hushmail.com",
	"tutanota.com",
	"tuta.io",
	"duck.com",
	"hey.com"
]);

export function isPublicEmailDomain(domain: string | null | undefined): boolean {
	return !!domain && PUBLIC_EMAIL_DOMAINS.has(domain.toLowerCase());
}
